"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Benefits = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ComponentHeader = require("../../base-components/ComponentHeader/ComponentHeader");
var _BulletListItem = require("../../base-components/BulletListItem/BulletListItem");
var _Image = require("../../base-components/Image/Image");
var _excluded = ["Component"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Benefits = exports.Benefits = function Benefits(_ref) {
  var className = _ref.className,
    image = _ref.image,
    Item = _ref.Item,
    items = _ref.items,
    styles = _ref.styles,
    title = _ref.title,
    titleProps = _ref.titleProps,
    subTitle = _ref.subTitle,
    namespace = _ref.namespace,
    qeId = _ref.qeId;
  var classNames = (0, _classnames["default"])('benefits', className, styles.benefits.benefitsContainer);
  var SubTitle = subTitle.Component,
    subTitleProps = _objectWithoutProperties(subTitle, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classNames,
    "data-qe-id": qeId
  }, title && /*#__PURE__*/_react["default"].createElement(_ComponentHeader.ComponentHeader, _extends({
    title: title,
    styles: styles.title
  }, titleProps, {
    namespace: namespace,
    qeId: qeId ? "".concat(qeId, "__title") : undefined
  })), subTitle && /*#__PURE__*/_react["default"].createElement(SubTitle, _extends({
    className: styles.subHeader
  }, subTitleProps, {
    namespace: namespace,
    "data-qe-id": qeId ? "".concat(qeId, "__subTitle") : undefined
  })), image && /*#__PURE__*/_react["default"].createElement(_Image.Image, {
    className: "benefit-image",
    src: image.imageUrl,
    alt: image.alt,
    namespace: namespace
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "benefitItems"
  }, items.map(function (itemProps, i) {
    var key = itemProps.key || "benefit-item-".concat(i);
    return /*#__PURE__*/_react["default"].createElement(Item, _extends({}, itemProps, {
      key: key,
      namespace: namespace,
      qeId: qeId ? "".concat(qeId, "__item").concat(i + 1) : undefined
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "benefitsMobileText"
  }, "Swipe right to view more"));
};
Benefits.propTypes = {
  className: _propTypes["default"].string,
  image: _propTypes["default"].shape({
    alt: _propTypes["default"].string.isRequired,
    imageUrl: _propTypes["default"].string.isRequired
  }),
  Item: _propTypes["default"].func,
  items: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired,
  styles: _propTypes["default"].shape({
    benefits: _propTypes["default"].shape({
      benefitsContainer: _propTypes["default"].string
    }).isRequired,
    title: _propTypes["default"].object
  }),
  title: _propTypes["default"].string,
  titleProps: _propTypes["default"].shape({
    Component: _propTypes["default"].node
  }),
  namespace: _propTypes["default"].string,
  subTitle: _propTypes["default"].shape({
    Component: _propTypes["default"].node,
    children: _propTypes["default"].node
  }),
  qeId: _propTypes["default"].string
};
Benefits.defaultProps = {
  className: undefined,
  image: null,
  Item: _BulletListItem.BulletListItem,
  styles: {
    title: {}
  },
  title: null,
  titleProps: {
    Component: undefined
  },
  subTitle: {
    Component: 'div',
    children: undefined
  },
  namespace: '',
  qeId: undefined
};